import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Link } from 'react-router-dom';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  href?: string;
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  href,
  fullWidth = false,
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-500 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-navy-600 text-white hover:bg-navy-700 shadow-sm shadow-navy-200',
    secondary: 'bg-white text-navy-600 border border-navy-200 hover:bg-navy-50 shadow-sm',
    outline: 'border-2 border-navy-600 text-navy-600 hover:bg-navy-50',
    ghost: 'text-navy-600 hover:bg-navy-50'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const content = <>{children}</>;
  if (href) {
    return <Link to={href} className={combinedClassName} data-id="element-97">
        {content}
      </Link>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} type={type} {...props} data-id="element-98">
      {content}
    </motion.button>;
}